import {FilterFieldAbstract} from "./filter-field.abstract";
import {FilterDirective} from "./container/filter.directive";
import {Component, forwardRef, Inject, Input} from "@angular/core";
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'tfl-filter-field-amount-range',
    template: `<div [formGroup]="formGroup"
     [ngClass]="getFormGroupClasses()">

    <label [for]="id"
           [ngClass]="getFormLabelClasses()">
        {{ label | translate }}:
    </label>

    <div [ngClass]="getFormControlClasses()">
        <tfl-amount-range
            id="id"
            name="name"
            [minValueName]="minValueName"
            [maxValueName]="maxValueName"
            [formControlName]="controlName"
        >
        </tfl-amount-range>
    </div>
</div>`
})

export class FilterFieldAmountComponent extends FilterFieldAbstract {

    @Input('id') id: string;
    @Input('label') label: string;
    @Input('controlName') controlName: string;
    @Input('minValueName') minValueName: string = 'minValue';
    @Input('maxValueName') maxValueName: string = 'maxValue';
    @Input('formGroup') formGroup: FormGroup;

    protected filter: FilterDirective;

    constructor(@Inject(forwardRef(() => FilterDirective)) filter: FilterDirective) {
        super();
        this.filter = filter;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/filter-field-amount.component.ts